import { render, staticRenderFns } from "./usercount.vue?vue&type=template&id=23b748ee"
import script from "./usercount.vue?vue&type=script&lang=js"
export * from "./usercount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports